import jsPDF from "jspdf";
import drawCommonPdfHeader from "./CommonPdfHeader/CommonPdfHeader";
import { normalizePartyNames } from "./TruncateParties";
import { districtCourtMapping } from "../constants/districtCourtMap";

export const exportCasesToPDF = (cases, orientation = 'portrait', globalSettings = null, isSingleCaseExport = false, remarksData = []) => {

  const doc = new jsPDF({
    orientation: orientation,
    unit: 'pt',
    format: 'a4'
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const margin = 46;
  let y = 55;

  // [Helper function getCompanyName kept as is...]
  // const getCompanyName = () => {
  //   try {
  //     const globalSettings = localStorage.getItem("globalSettings");
  //     // ... (rest of your getCompanyName logic) ...
  //     return "LawSuit(Pro)";
  //   } catch (error) {
  //     return "LawSuit(Pro)";
  //   }
  // };
  const getCompanyName = () => {
    try {
      const globalSettings = localStorage.getItem("globalSettings");
      const company = localStorage.getItem("company");
      const userData = localStorage.getItem("userData");
      const userProfile = localStorage.getItem("userProfile");

      if (globalSettings) {
        const settings = JSON.parse(globalSettings);
        if (settings.companyName) return settings.companyName;
      }
      if (company) {
        const companyData = JSON.parse(company);
        if (companyData.companyName) return companyData.companyName;
        if (companyData.name) return companyData.name;
      }
      if (userData) {
        const user = JSON.parse(userData);
        if (user.companyName) return user.companyName;
        if (user.company && user.company.name) return user.company.name;
      }
      if (userProfile) {
        const profile = JSON.parse(userProfile);
        if (profile.companyName) return profile.companyName;
        if (profile.company) return profile.company;
      }
      return "LawSuit(Pro)";
    } catch (error) {
      console.error("Error retrieving company name:", error);
      return "LawSuit(Pro)";
    }
  };

  const colors = {
    primary: [0, 82, 204],
    secondary: [52, 73, 94],
    pending: [218, 92, 25],
    disposed: [104, 104, 104],
    background: [248, 249, 250],
    text: [44, 62, 80],
    border: [189, 195, 199],
    headerBg: [41, 128, 185],
    altRow: [236, 240, 241],
    black: [33, 37, 41],
    gray: [108, 117, 125],
    borderGray: [222, 226, 230],
    blue: [0, 123, 255]
  };

  const companyName = getCompanyName();
  // Determine if Custom Columns should be shown based on passed Global Settings
  let showCustomColumns = false;
  if (globalSettings) {
    // Handle structure: direct object or API result wrapper
    const targetSettings = globalSettings.result[0];
    if (targetSettings?.cases?.allowCustomColumns) {
      showCustomColumns = true;
    }
  }

  const addHeader = () => {
    return drawCommonPdfHeader(doc, companyName, pageWidth, margin, colors);
  };

  const headerEndY = addHeader();
  y = headerEndY + 30;

  // Title & Subtitle Section
  doc.setFontSize(17);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...colors.primary);
  const reportTitle = isSingleCaseExport ? "Case Details" : "Cases Detail Report";
  doc.text(reportTitle, (pageWidth - doc.getTextWidth(reportTitle)) / 2, y);
  y += 25;

  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(...colors.secondary);
  const subtitle = `Generated on ${new Date().toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' })}`;
  doc.text(subtitle, (pageWidth - doc.getTextWidth(subtitle)) / 2, y);
  y += 25;

  doc.setFontSize(11);
  doc.setTextColor(...colors.text);
  if (!isSingleCaseExport) {
    doc.text(`Total Cases: ${cases.length}`, margin, y);
    y += 15;
  }

  doc.setDrawColor(...colors.border);
  doc.setLineWidth(1);
  doc.line(margin, y, pageWidth - margin, y);
  y += 30;

  const marginLeft = margin;
  const marginRight = margin;
  const availableWidth = pageWidth - marginLeft - marginRight;

  // LOOP THROUGH CASES
  cases.forEach((caseData, index) => {
    // Normalize data: 'c' holds the inner case object
    const c = caseData.case || caseData;
    // --- DISTRICT COURT MAPPING LOGIC (ROBUST VERSION) ---
    let displayState = String(c.caseStatus?.["State"] || 'N/A');
    let displayDistrict = String(c.caseStatus?.["District"] || 'N/A');
    let displayCourt = String( c.courtName || c.court ||'N/A');

    // --- Page Break Logic ---
    const minSpaceNeeded = orientation === 'landscape' ? 170 : 150;
    if (y + minSpaceNeeded > pageHeight - 50) {
      doc.addPage();
      const newHeaderEndY = addHeader();
      y = newHeaderEndY + 30;
    }

    // --- Case Header Background ---
    // doc.setFillColor(...colors.headerBg);
    // doc.rect(marginLeft, y - 10, availableWidth, 42, 'F');

    // doc.setFontSize(orientation === 'landscape' ? 12 : 14);
    // doc.setFont("helvetica", "bold");
    // doc.setTextColor(255, 255, 255);

    // const caseTitle = isSingleCaseExport 
    //   ? `Case No:${String(c.caseTypeAndNumber || 'N/A')}` 
    //   : `Case #${index + 1}: ${String(c.caseTypeAndNumber || 'N/A')}`;
    // const maxTitleWidth = availableWidth - 150;
    // const truncatedTitle = doc.getTextWidth(caseTitle) > maxTitleWidth
    //   ? caseTitle.substring(0, orientation === 'landscape' ? 60 : 70) + '...'
    //   : caseTitle;
    // const courtName = displayCourt || 'N/A';
    // const partyNames = normalizePartyNames(c.parties) || 'N/A';
    // const caseNo = c.caseTypeAndNumber || 'N/A';
    // const formattedTitle = `Court Name: ${courtName} | Party Name: ${partyNames} | Case No: ${caseNo}`;
    // const caseTitle = isSingleCaseExport
    //   ? formattedTitle
    //   : `Case #${index + 1}: ${formattedTitle}`;
    // const maxTitleWidth = availableWidth - 150;
    // const truncatedTitle = doc.getTextWidth(caseTitle) > maxTitleWidth
    //   ? caseTitle.substring(0, orientation === 'landscape' ? 90 : 75) + '...'
    //   : caseTitle;

    // doc.text(truncatedTitle, marginLeft + 10, y + 18);

    // --- Case Header Background (Increased height to 65 for 3 rows) ---

    // --- 1. Resolve Status & Badge Logic FIRST (to calculate space) ---
    // SC cases carry their status directly in caseStatus["Status"]; skip hearing-date logic for them.
    const scRawStatus = c.caseStatus?.["Status"];
    let status;
    if (scRawStatus) {
      status = String(scRawStatus);
    } else {
      status = String(c.caseStatus?.["Case Status"] || 'N/A');
      const nextHearingRaw = c.customUndatedRows?.["Next Hearing Date"] || c.caseStatus?.["Next Hearing Date"];
      if (!status.toUpperCase().includes('DISPOSED')) {
        let isFutureOrToday = false;
        if (nextHearingRaw) {
          const cleanDateStr = nextHearingRaw.replace(/(\d+)(st|nd|rd|th)/i, '$1');
          let hearingDate = new Date(cleanDateStr);
          if (isNaN(hearingDate.getTime()) && nextHearingRaw.includes('-')) {
            const parts = nextHearingRaw.split('-');
            if (parts.length === 3) {
              hearingDate = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
            }
          }
          if (!isNaN(hearingDate.getTime())) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            if (hearingDate >= today) {
              isFutureOrToday = true;
            }
          }
        }
        status = isFutureOrToday ? 'Pending' : 'N/A';
      }
    }

    const statusColor = status.toUpperCase().includes('DISPOSED') ? colors.disposed :
      status.toUpperCase().includes('PENDING') ? colors.pending : colors.secondary;

    // Calculate Badge Dimensions
    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");
    const statusTextWidth = doc.getTextWidth(status);
    const badgePadding = 16;
    const badgeWidth = Math.min(statusTextWidth + badgePadding, 100);
    const badgeHeight = 24;

    // --- 2. Draw Header Background ---
    // Increased height to 75 to comfortably fit 3 rows of text + spacing
    const headerBoxHeight = 70; 
    doc.setFillColor(...colors.headerBg);
    doc.rect(marginLeft, y - 10, availableWidth, headerBoxHeight, 'F');

    // --- 3. Render Status Badge (Top Right, Vertically Centered in Box) ---
    // Center the badge vertically relative to the header box
    const badgeX = pageWidth - marginRight - badgeWidth - 10;
    const badgeY = (y - 10) + (headerBoxHeight / 2) - (badgeHeight / 2); 

    doc.setFillColor(...statusColor);
    doc.roundedRect(badgeX, badgeY, badgeWidth, badgeHeight, 8, 8, 'F');
    doc.setTextColor(255, 255, 255);
    
    const truncatedStatus = doc.getTextWidth(status) > badgeWidth - 10
      ? status.substring(0, 12) + '...'
      : status;
    doc.text(truncatedStatus, badgeX + 8, badgeY + 16);

    // --- 4. Render 3-Row Title (Avoid Overlap) ---
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(255, 255, 255);

    // Calculate width available for text (Total width - Badge width - Padding)
    const maxTextWidth = availableWidth - badgeWidth - 30; 
    
    const titleX = marginLeft + 10;
    let currentTextY = y + 5; // Start drawing text slightly down from top

    const rowData = [
        { label: "Court Name: ", value: displayCourt || 'N/A' },
        { label: "Party Name: ", value: normalizePartyNames(c.parties) || 'N/A' },
        { label: "Case No: ", value: c.caseTypeAndNumber || 'N/A' }
    ];

   rowData.forEach((row) => {
        // 1. Set Font & Color for LABEL (Light Gray)
        doc.setFont("helvetica", "bold"); 
        doc.setTextColor(255,255,255); // Light Gray
        doc.text(row.label, titleX, currentTextY);

        // Calculate offset so Value starts right after Label
        const labelWidth = doc.getTextWidth(row.label);
        
        // 2. Set Font & Color for VALUE (White & Bold)
        doc.setFont("helvetica", "bold");
        doc.setTextColor(255, 215, 90); // Pure White

        // Calculate available width for the value (Total width - Label width)
        const valueMaxWidth = maxTextWidth - labelWidth;
        
        // Wrap the value text if it's too long
        const splitValue = doc.splitTextToSize(row.value, valueMaxWidth);
        
        // Draw the value at the offset position
        doc.text(splitValue, titleX + labelWidth, currentTextY);

        // 3. Dynamic Height Adjustment
        const lineHeight = 12;
        // Use the number of lines in the value to determine height
        const blockHeight = splitValue.length * lineHeight;
        
        // Add extra padding (6) between rows
        currentTextY += blockHeight + 6; 
    });

    // --- 5. Advance Y Position for Body Content ---
    y += headerBoxHeight - 8;
    

    // --- Party Info Helper ---
    const getDetailedPartyInfo = () => {
      let pName = 'N/A', pAdv = 'N/A', rName = 'N/A', rAdv = 'N/A';

      if (c.petitionerAndAdvocate) {
        const pa = c.petitionerAndAdvocate;
        const getVal = (k1, k2) => {
          const v = pa[k1] || pa[k2];
          return Array.isArray(v) ? v.join(', ') : (v || 'N/A');
        };
        pName = getVal('petitioner', 'petitioners');
        pAdv = getVal('advocate', 'advocates');
        rName = getVal('respondent', 'respondents');
        rAdv = getVal('respondentAdvocate', 'respondentAdvocates');
      } else {
        if (c.partyDetails && Array.isArray(c.partyDetails)) {
          pName = c.partyDetails.join(', ');
        }
        pAdv = c.advocates || 'N/A';
        if (c.respondentDetails && Array.isArray(c.respondentDetails)) {
          rName = c.respondentDetails.map(r => r.party || '').filter(Boolean).join(', ');
          rAdv = c.respondentDetails.map(r => r.advocate || '').filter(Boolean).join(', ');
        }
      }
      return { pName, pAdv, rName, rAdv };
    };

    const { pName, pAdv, rName, rAdv } = getDetailedPartyInfo();



    // Logic: If 'stateCourtComplex' exists, it implies District Court data structure
    if ((caseData.source === 'districtCourt' || c.stateCourtComplex) && districtCourtMapping) {


      const sCode = String(c.state);
      const dCode = String(c.stateDistrict);
      const cCode = String(c.stateCourtComplex);

      // 1. Resolve State
      if (sCode && districtCourtMapping.states && districtCourtMapping.states[sCode]) {
        displayState = districtCourtMapping.states[sCode].name;

        // 2. Resolve District
        if (dCode && districtCourtMapping.states[sCode].districts && districtCourtMapping.states[sCode].districts[dCode]) {
          displayDistrict = districtCourtMapping.states[sCode].districts[dCode].name;

          // 3. Resolve Court Complex
          const complexMap = districtCourtMapping.states[sCode].districts[dCode].courtComplexes;
          if (cCode && complexMap && complexMap[cCode]) {
            displayCourt = complexMap[cCode].name;
          }
        }
      }
    } else {
      if (!districtCourtMapping) console.warn("Mapping file not loaded");
    }

    // --- Details Array ---
    const details = [
      // { label: 'Parties', value: String(normalizePartyNames(c.parties) || 'N/A') },
      { label: 'CNR Number', value: String(c.caseDetails?.["CNR Number"] || 'N/A') },
      { label: 'Filing Number', value: String(c.caseDetails?.["Filing Number"] || 'N/A') },
      { label: 'Filing Date', value: String(c.caseDetails?.["Filing Date"] || 'N/A') },
      { label: 'Registration Number', value: String(c.caseDetails?.["Registration Number"] || 'N/A') },
      { label: 'Next Hearing Date', value: String(c.customUndatedRows?.["Next Hearing Date"] || c.caseStatus?.["Next Hearing Date"] || 'N/A'), isCustomDate: !!c.customUndatedRows?.["Next Hearing Date"] },
      { label: 'Registration Date', value: String(c.caseDetails?.["Registration Date"] || c.caseDetails?.["Registration Date:"] || 'N/A') },
      { label: 'First Hearing Date', value: String(c.caseStatus?.["First Hearing Date"] || 'N/A') },
      { label: 'Decision Date', value: String(c.caseStatus?.["Decision Date"] || 'N/A') },
      { label: 'Case Status', value: String(c.caseStatus?.["Case Status"] || c.caseStatus?.["Status"] || c.caseStatus?.["Case Stage"] || 'N/A') },
      { label: 'Nature of Disposal', value: String(c.caseStatus?.["Nature of Disposal"] || 'N/A') },
      { label: 'Coram', value: String(c.caseStatus?.["Coram"] || c.caseStatus?.["Court Number and Judge"] || "N/A") },
      { label: 'Bench Type', value: String(c.caseStatus?.["Bench Type"] || 'N/A') },
      { label: 'Judicial Branch', value: String(c.caseStatus?.["Judicial Branch"] || 'N/A') },

      // Mapped Variables
      { label: 'State', value: displayState },
      { label: 'District', value: displayDistrict },
      // { label: 'Court', value: displayCourt },

      { label: 'Advocates', value: String(c.advocates || 'N/A') },
      { label: 'Petitioner', value: pName },
      { label: 'Petitioner Advocate', value: pAdv },
      { label: 'Respondent', value: rName },
      { label: 'Respondent Advocate', value: rAdv },

      { label: 'Category', value: String(c.categoryDetails?.["Category"] || 'N/A') },
      { label: 'Sub Category', value: String(c.categoryDetails?.["Sub Category"] || 'N/A') }
    ];

    // Add Acts and Sections as separate rows
    const actsAndSectionsData = c.actsData || c.actsAndSections || [];
    actsAndSectionsData.forEach((item, index) => {
      const actName = item?.["underAct"] || item?.["act"] || '';
      const sectionName = item?.["underSection"] || item?.["section"] || '';
      if (actName || sectionName) {
        details.push({
          label: 'Acts and Section',
          value: `${actName}${sectionName ? ' - Section: ' + sectionName : ''}`
        });
      }
    });

    // Add remaining details
    details.push(
      { label: 'Serial Number', value: String(c.serialNumber || 'N/A') },
      { label: 'Case Type & Number', value: String(c.caseTypeAndNumber || 'N/A') },
      { label: 'Latest Hearing Date', value: String(c.caseHistory?.[0]?.["hearingDate"] || c.historyData?.[0]?.["hearingDate"] || 'N/A') },
      { label: 'Latest Purpose of Hearing', value: String(c.caseHistory?.[0]?.["purposeOfHearing"] || c.historyData?.[0]?.["purposeOfHearing"] || 'N/A') },
      { label: 'Latest Business On Date', value: String(c.caseHistory?.[0]?.["businessOnDate"] || c.historyData?.[0]?.["businessOnDate"] || 'N/A') },
      { label: 'Latest Judge', value: String(c.caseHistory?.[0]?.["judge"] || c.historyData?.[0]?.["judge"] || 'N/A') }
    );
    // --- Insert Custom Columns if Enabled ---
    if (showCustomColumns && c.customAttributes && Array.isArray(c.customAttributes.columns)) {
      c.customAttributes.columns.forEach(col => {
        // Only show if value exists and is not empty
        if (col.value && String(col.value).trim() !== "") {
          // Format label: camelCase -> Title Case (e.g., insuranceId -> Insurance Id)
          const formattedLabel = col.name
            ? col.name.charAt(0).toUpperCase() + col.name.slice(1).replace(/([A-Z])/g, ' $1')
            : 'Custom Field';

          details.push({
            label: formattedLabel,
            value: String(col.value)
          });
        }
      });
    }

    // Filter Logic: Explicitly include State/District/Court even if N/A
    const relevantDetails = details.filter(detail =>
      detail.value !== 'N/A' ||
      ['Parties', 'CNR Number', 'Filing Date', 'Case Status', 'Coram', 'State', 'District', 'Court'].includes(detail.label)
    );

    // --- GRID RENDERING LOGIC (Shared for Portrait/Landscape) ---
    const labelWidth = 140;
    const landscapeColWidth = (availableWidth - 30) / 2;
    const landscapeLeftX = marginLeft;
    const landscapeRightX = marginLeft + landscapeColWidth + 30;
    const landscapeLabelGap = 135;

    let currentY = y;

    if (orientation === 'landscape') {
      for (let i = 0; i < relevantDetails.length; i += 2) {
        const item1 = relevantDetails[i];
        const item2 = relevantDetails[i + 1];

        const maxWidth = landscapeColWidth - (landscapeLabelGap + 10);
        const valueLines1 = doc.splitTextToSize(item1.value, maxWidth);
        const height1 = Math.max(20, valueLines1.length * 12 + 6);

        let height2 = 0;
        let valueLines2 = [];
        if (item2) {
          valueLines2 = doc.splitTextToSize(item2.value, maxWidth);
          height2 = Math.max(20, valueLines2.length * 12 + 6);
        }

        const rowHeight = Math.max(height1, height2);

        if (currentY + rowHeight > pageHeight - 50) {
          doc.addPage();
          const newHeaderEndY = addHeader();
          currentY = newHeaderEndY + 30;
        }

        if ((i / 2) % 2 === 0) {
          doc.setFillColor(...colors.altRow);
          doc.rect(landscapeLeftX, currentY - 2, landscapeColWidth, rowHeight, 'F');
          if (item2) doc.rect(landscapeRightX, currentY - 2, landscapeColWidth, rowHeight, 'F');
        }

        // Left Item
        doc.setFontSize(9);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(...colors.secondary);
        doc.text(item1.label + ':', landscapeLeftX + 5, currentY + 11);
        doc.setFont("helvetica", "normal");
        // Apply green color if this is a custom next hearing date
        if (item1.isCustomDate) {
          doc.setTextColor(5, 150, 105); // #059669 in RGB
        } else {
          doc.setTextColor(...colors.text);
        }
        for (let lineIndex = 0; lineIndex < valueLines1.length; lineIndex++) {
          doc.text(String(valueLines1[lineIndex]), landscapeLeftX + landscapeLabelGap, currentY + 11 + (lineIndex * 12));
        }

        // Right Item
        if (item2) {
          doc.setFontSize(9);
          doc.setFont("helvetica", "bold");
          doc.setTextColor(...colors.secondary);
          doc.text(item2.label + ':', landscapeRightX + 5, currentY + 11);
          doc.setFont("helvetica", "normal");
          // Apply green color if this is a custom next hearing date
          if (item2.isCustomDate) {
            doc.setTextColor(5, 150, 105); // #059669 in RGB
          } else {
            doc.setTextColor(...colors.text);
          }
          for (let lineIndex = 0; lineIndex < valueLines2.length; lineIndex++) {
            doc.text(String(valueLines2[lineIndex]), landscapeRightX + landscapeLabelGap, currentY + 11 + (lineIndex * 12));
          }
        }
        currentY += rowHeight;
      }
      y = currentY + 15;
    } else {
      // Portrait
      relevantDetails.forEach((detail, detailIndex) => {
        const maxWidth = availableWidth - labelWidth - 20;
        const valueLines = doc.splitTextToSize(detail.value, maxWidth);
        const rowHeight = Math.max(22, valueLines.length * 12 + 8);

        if (currentY + rowHeight > pageHeight - 50) {
          doc.addPage();
          const newHeaderEndY = addHeader();
          currentY = newHeaderEndY + 30;
        }

        if (detailIndex % 2 === 0) {
          doc.setFillColor(...colors.altRow);
          doc.rect(marginLeft, currentY - 3, availableWidth, rowHeight, 'F');
        }

        doc.setFontSize(9);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(...colors.secondary);
        doc.text(detail.label + ':', marginLeft + 5, currentY + 12);

        doc.setFont("helvetica", "normal");
        // Apply green color if this is a custom next hearing date
        if (detail.isCustomDate) {
          doc.setTextColor(5, 150, 105); // #059669 in RGB
        } else {
          doc.setTextColor(...colors.text);
        }

        if (valueLines.length > 1) {
          valueLines.forEach((line, lineIndex) => {
            doc.text(String(line), marginLeft + labelWidth, currentY + 12 + (lineIndex * 12));
          });
        } else {
          doc.text(String(detail.value), marginLeft + labelWidth, currentY + 12);
        }
        currentY += rowHeight;
      });
      y = currentY;
    }

    //CASE HISTORY SECTION (Only for Single Case Export)
    if (isSingleCaseExport && (c.caseHistory || c.historyCaseData)) {
      let historyData = c.caseHistory || c.historyCaseData || [];

      // Sort by hearing date in descending order (newest first)
      historyData = historyData.slice().sort((a, b) => {
        const dateA = a.hearingDate || '';
        const dateB = b.hearingDate || '';

        // Parse dates in DD-MM-YYYY format
        const parseDate = (dateStr) => {
          if (!dateStr || dateStr === 'N/A' || dateStr === '') return new Date(0);
          const parts = dateStr.split('-');
          if (parts.length === 3) {
            // DD-MM-YYYY format
            return new Date(parts[2], parts[1] - 1, parts[0]);
          }
          return new Date(dateStr);
        };

        return parseDate(dateB) - parseDate(dateA); // Descending order
      });

      // Check if there's any valid history data to display
      const hasValidHistory = historyData.some(history => {
        const hearingDate = history.hearingDate || '';
        const judge = history.judge || '';
        const businessOnDate = history.businessOnDate || '';
        const purposeOfHearing = history.purposeOfHearing || '';
        const matchingRemark = remarksData.find(r => r.hearingDate === hearingDate);
        const remark = matchingRemark?.remark || '';

        return (hearingDate && hearingDate !== 'N/A') ||
          (judge && judge !== 'N/A') ||
          (businessOnDate && businessOnDate !== 'N/A') ||
          (purposeOfHearing && purposeOfHearing !== 'N/A') ||
          (remark && remark !== 'N/A');
      });

      if (hasValidHistory) {
        y += 25; // Add spacing before history section

        // Check if we need a new page for section header
        if (y + 50 > pageHeight - 50) {
          doc.addPage();
          const newHeaderEndY = addHeader();
          y = newHeaderEndY + 30;
        }

        // Section Header - "Case History" with Border Box
        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(...colors.primary);
        const historyTitle = "Case History";
        const titleWidth = doc.getTextWidth(historyTitle);
        const boxPadding = 20;
        const boxWidth = titleWidth + boxPadding;
        const boxHeight = 35;
        const boxX = (pageWidth - boxWidth) / 2;

        // Draw border box
        doc.setDrawColor(...colors.primary);
        doc.setLineWidth(2);
        doc.rect(boxX, y - 5, boxWidth, boxHeight, 'S');

        // Draw text centered in box
        doc.text(historyTitle, (pageWidth - titleWidth) / 2, y + 18);
        y += 50;

        // Process each history entry separately with gaps between them
        historyData.forEach((history, histIndex) => {
          const hearingDate = history.hearingDate || '';
          const judge = history.judge || '';
          const businessOnDate = history.businessOnDate || '';
          const purposeOfHearing = history.purposeOfHearing || '';

          // Find matching remark
          const matchingRemark = remarksData.find(r => r.hearingDate === hearingDate);
          const remark = matchingRemark?.remark || '';

          // Build details array for this specific history entry
          const entryDetails = [];

          // Add fields only if they have data
          if (hearingDate && hearingDate !== 'N/A') {
            entryDetails.push({
              label: `Hearing Date`,
              value: hearingDate
            });
          }

          if (judge && judge !== 'N/A') {
            entryDetails.push({
              label: `Judge`,
              value: judge
            });
          }

          if (businessOnDate && businessOnDate !== 'N/A') {
            entryDetails.push({
              label: `Business On Date`,
              value: businessOnDate
            });
          }

          if (purposeOfHearing && purposeOfHearing !== 'N/A') {
            entryDetails.push({
              label: `Purpose of Hearing`,
              value: purposeOfHearing
            });
          }

          if (remark && remark !== 'N/A') {
            entryDetails.push({
              label: `Remarks`,
              value: remark
            });
          }

          // Only render if there's at least one field with data
          if (entryDetails.length > 0) {
            // Render this history entry
            entryDetails.forEach((detail, detailIndex) => {
              const maxWidth = availableWidth - labelWidth - 20;
              const valueLines = doc.splitTextToSize(detail.value, maxWidth);
              const rowHeight = Math.max(22, valueLines.length * 12 + 8);

              if (y + rowHeight > pageHeight - 50) {
                doc.addPage();
                const newHeaderEndY = addHeader();
                y = newHeaderEndY + 30;
              }

              // Alternate row background within each entry
              if (detailIndex % 2 === 0) {
                doc.setFillColor(...colors.altRow);
                doc.rect(marginLeft, y - 3, availableWidth, rowHeight, 'F');
              }

              doc.setFontSize(9);
              doc.setFont("helvetica", "bold");
              doc.setTextColor(...colors.secondary);
              doc.text(detail.label + ':', marginLeft + 5, y + 12);

              doc.setFont("helvetica", "normal");
              doc.setTextColor(...colors.text);

              if (valueLines.length > 1) {
                valueLines.forEach((line, lineIndex) => {
                  doc.text(String(line), marginLeft + labelWidth, y + 12 + (lineIndex * 12));
                });
              } else {
                doc.text(String(detail.value), marginLeft + labelWidth, y + 12);
              }

              y += rowHeight;
            });

            // Add gap between history entries (but not after the last one)
            if (histIndex < historyData.length - 1) {
              y += 20; // Increased gap between entries

              // Add a more prominent separator line between entries
              doc.setDrawColor(...colors.border);
              doc.setLineWidth(1);
              doc.setLineDash([3, 3], 0);
              doc.line(marginLeft, y - 10, pageWidth - marginRight, y - 10);
              doc.setLineDash([], 0); // Reset to solid line

              y += 10; // Additional spacing after separator
            }
          }
        });

        y += 10; // Add spacing after history section
      }
    }

    if (index < cases.length - 1) {
      doc.setDrawColor(...colors.border);
      doc.setLineWidth(0.5);
      doc.line(marginLeft, y + 10, pageWidth - marginRight, y + 10);
      y += 40;
    }
  });

  // --- Summary & Page Numbers ---
  if (!isSingleCaseExport) {
    if (y > pageHeight - 160) {
      doc.addPage();
      const newHeaderEndY = addHeader();
      y = newHeaderEndY + 30;
    } else {
      y = Math.max(y + 30, pageHeight - 150);
    }

    const disposedCases = cases.filter(item => {
      const c = item.case || item;
      return c.caseStatus?.["Case Status"]?.includes('DISPOSED');
    }).length;
    const pendingCases = cases.length - disposedCases;

    doc.setFillColor(...colors.background);
    doc.rect(marginLeft, y, availableWidth, 80, 'F');
    doc.setDrawColor(...colors.border);
    doc.rect(marginLeft, y, availableWidth, 80, 'S');

    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(...colors.secondary);
    doc.text("Report Summary", marginLeft + 15, y + 25);

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(...colors.text);
    doc.text(`Total Cases: ${cases.length}`, marginLeft + 15, y + 45);
    doc.text(`Disposed: ${disposedCases}`, marginLeft + 15, y + 60);
    doc.text(`Pending: ${pendingCases}`, marginLeft + 150, y + 60);
  }

  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(...colors.text);
    doc.text(`Page ${i} of ${totalPages}`, pageWidth / 2, pageHeight - 20, { align: "center" });
  }

  const filename = isSingleCaseExport
    ? `case_details_${orientation}_${new Date().toISOString().split('T')[0]}.pdf`
    : `cases_detail_report_${orientation}_${new Date().toISOString().split('T')[0]}.pdf`;
  doc.save(filename);
};